/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Text_Content_Exceeds_HintInputs */

const en_error_nav_text_content_exceeds_hint = /** @type {(inputs: Error_Nav_Text_Content_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduce the number of characters per line or reduce the number of lines in the Event.`)
};

const fr_error_nav_text_content_exceeds_hint = /** @type {(inputs: Error_Nav_Text_Content_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduisez le nombre de caracteres par ligne ou le nombre de lignes de l'evenement.`)
};

const de_error_nav_text_content_exceeds_hint = /** @type {(inputs: Error_Nav_Text_Content_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verringern Sie die Anzahl der Zeichen pro Zeile oder die Anzahl der Zeilen im Ereignis.`)
};

const it_error_nav_text_content_exceeds_hint = /** @type {(inputs: Error_Nav_Text_Content_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ridurre il numero di caratteri per riga o ridurre il numero di righe nell'evento.`)
};

const ru_error_nav_text_content_exceeds_hint = /** @type {(inputs: Error_Nav_Text_Content_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уменьшите количество символов в строке или уменьшите количество строк в событии.`)
};

const es_error_nav_text_content_exceeds_hint = /** @type {(inputs: Error_Nav_Text_Content_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reducir el número de caracteres por línea o reducir el número de líneas en el evento.`)
};

const zh_cn2_error_nav_text_content_exceeds_hint = /** @type {(inputs: Error_Nav_Text_Content_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减少每行字符数或减少事件中的行数。`)
};

const ja_error_nav_text_content_exceeds_hint = /** @type {(inputs: Error_Nav_Text_Content_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 行あたりの文字数を減らすか、イベント内の行数を減らします。`)
};

const hi_error_nav_text_content_exceeds_hint = /** @type {(inputs: Error_Nav_Text_Content_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति पंक्ति वर्णों की संख्या कम करें या इवेंट में पंक्तियों की संख्या कम करें।`)
};

const pt_pt2_error_nav_text_content_exceeds_hint = /** @type {(inputs: Error_Nav_Text_Content_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduza o número de caracteres por linha ou reduza o número de linhas no evento.`)
};

/**
* | output |
* | --- |
* | "Reduce the number of characters per line or reduce the number of lines in the Event." |
*
* @param {Error_Nav_Text_Content_Exceeds_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_text_content_exceeds_hint = /** @type {((inputs?: Error_Nav_Text_Content_Exceeds_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Text_Content_Exceeds_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_text_content_exceeds_hint(inputs)
	if (locale === "de") return de_error_nav_text_content_exceeds_hint(inputs)
	if (locale === "it") return it_error_nav_text_content_exceeds_hint(inputs)
	if (locale === "ru") return ru_error_nav_text_content_exceeds_hint(inputs)
	if (locale === "es") return es_error_nav_text_content_exceeds_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_text_content_exceeds_hint(inputs)
	if (locale === "ja") return ja_error_nav_text_content_exceeds_hint(inputs)
	if (locale === "hi") return hi_error_nav_text_content_exceeds_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_text_content_exceeds_hint(inputs)
	return en_error_nav_text_content_exceeds_hint(inputs)
});